import React from 'react'
import { useValidation } from '../Hooks/useValidation'

function Required() {
  const { validation } = useValidation();
  
  return (
    <abbr title={validation?.mandatory_field || "Campo obligatorio"} className="campo-obligatorio">
    *
  </abbr>
  )
}

export default Required